"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleAuthModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const simple_auth_service_1 = require("./simple-auth.service");
const simple_auth_controller_1 = require("./simple-auth.controller");
const user_1 = require("../../../../service-lib/src/lib/entities/user");
const user_role_entity_1 = require("../../../../service-lib/src/lib/entities/user-role.entity"); // Import UserRole entity
const roles_entity_1 = require("../../../../service-lib/src/lib/entities/roles.entity"); // Import Role entity
const simple_auth_repository_1 = require("./simple-auth.repository");
let SimpleAuthModule = class SimpleAuthModule {
};
exports.SimpleAuthModule = SimpleAuthModule;
exports.SimpleAuthModule = SimpleAuthModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([user_1.User, user_role_entity_1.UserRole, roles_entity_1.Role]), // Register UserRole and Role entities
        ],
        controllers: [simple_auth_controller_1.SimpleAuthController],
        providers: [simple_auth_service_1.SimpleAuthService, simple_auth_repository_1.UserRepository],
        exports: [simple_auth_repository_1.UserRepository],
    })
], SimpleAuthModule);
